import { OnInit } from '@angular/core';
import { ButtonViewComponent } from './button-renderer-crypto';

export class DownloadConfirmationRendererCrypto extends ButtonViewComponent implements OnInit {
  ngOnInit() {
    super.ngOnInit();
    this.renderValue = null;
    this.renderIcon = 'nb-play';
    this.disabled = this.value[ 'provider' ] !== 'Arvato';
  }
}



// WEBPACK FOOTER //
// ./src/app/pages-crypto/renderer-crypto/download-confirmation-renderer-crypto.ts